'use client';

import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import type { IGallery } from '@/entities/common/types/gallery';
interface GalleryThumbnailProps {
  index: number;
  image: IGallery;
  shouldLoad: boolean;
  onClick: (index: number) => void;
  imagesLength: number;
}
const GalleryThumbnail = React.forwardRef<HTMLDivElement, GalleryThumbnailProps>(({
  index,
  image,
  shouldLoad,
  onClick,
  imagesLength
}, ref) => {
  const t = useTranslations();
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div ref={ref} data-index={index} className="group relative h-16 w-24 flex-none cursor-pointer overflow-hidden rounded-lg border border-gray-200 transition-transform" onClick={() => onClick(index)} role="button" tabIndex={0} aria-label={t('shared.aria.open_image', {
      current: index + 1,
      total: imagesLength
    })}>
        <div className="absolute inset-0 bg-black opacity-0 transition-opacity group-hover:opacity-40" />
        {shouldLoad ? <Image width={100} height={65} src={image.thumbnail} alt={t('shared.aria.slide', {
        0: index + 1
      })} className="size-full object-cover" priority={index < 2} /> : <div className="size-full animate-pulse bg-gray-100" />}
      </div>
  );
});
GalleryThumbnail.displayName = 'GalleryThumbnail';
export { GalleryThumbnail };